import { useState } from "react";
import {
  Modal,
  Form,
  Input,
  Upload,
  Button,
  Image,
  message,
  Select,
} from "antd";
import callApi from "../../constants/API/CallApi";
import { ShowToast, Severty } from "../../helper/toast";
import { addBanner, getBranches } from "../../constants/API/API";
import { UploadOutlined } from "@ant-design/icons";
import { uploadFileToS3 } from "../../helper/uploadImage";
import useApi from "../../hooks/useApi";

const allowedImageTypes = ["image/png", "image/jpeg", "image/webp"];

const AddBanner = ({ visible, setVisible, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [branches, setBranches] = useState([]);

  useApi({
    callback: getBranches,
    dependencies: [refresh],
    shouldCallApi: true,
    onSuccess: ({ data }) => {
      const activeBranches = (data || []).filter((branch) => branch.isActive);
      setBranches(activeBranches);
    },
  });

  const handleOk = async (values) => {
    setLoading(true);
    callApi({
      callback: () => addBanner({ ...values }),
      payload: {},
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        refresh((x) => !x);
        setVisible(false);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const beforeUpload = (file, type) => {
    const validTypes = allowedImageTypes;
    if (!validTypes.includes(file.type)) {
      message.error("Unsupported file type.");
      return Upload.LIST_IGNORE;
    }
    if (file.size / 1024 / 1024 > 100) {
      message.error("File must be smaller than 100MB.");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleFileUpload = async (info) => {
    const { file } = info;
    setLoading(true);
    try {
      const data = await uploadFileToS3({
        file,
        bucketName: "invent-co-new",
        dirName: "event",
      });
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
      form.setFieldsValue({
        image: data.Location,//`${process.env.REACT_APP_AWS_S3_ENDPOINT}/${process.env.REACT_APP_AWS_S3_BUCKET_NAME}/` + data.Key,
      });
    } catch (error) {
      console.error(error);
      message.error("Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      className="tab_modal"
      title="Add Banner"
      okText="Create"
      onCancel={handleCancel}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      width={600}
      destroyOnClose
    >
      <Form
        id="create"
        form={form}
        onFinish={handleOk}
        layout="vertical"
        preserve={false}
        initialValues={{
          isActive: true,
          isDeleted: false,
        }}
      >
        <Form.Item
          name="title"
          label="Banner Title"
          normalize={(val) => val?.trimStart()}
          rules={[
            { required: true, message: "Please enter a banner title" },
            { max: 50, message: "Title cannot be longer than 50 characters" },
          ]}
        >
          <Input placeholder="Enter banner title" maxLength={50} />
        </Form.Item>

        <Form.Item
          name="link"
          label="Banner Link"
          normalize={(value) => value.trimStart()}
        // rules={[
        //   { required: true, message: "Please enter a banner link" },
        //   {
        //     pattern: /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/,
        //     message:
        //       "Please enter a valid URL starting with http:// or https://",
        //   },
        // ]}
        >
          <Input placeholder="https://example.com" />
        </Form.Item>

        <Form.Item
          name="branchId"
          label="Branch"
          rules={[{ required: true, message: "Please select branch!" }]}
        >
          <Select placeholder="Select Branch">
            {branches?.map((branch) => (
              <Select.Option key={branch?._id} value={branch?._id}>
                {branch?.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="image" label="Upload Banner Image">
          <Upload
            listType="picture"
            maxCount={1}
            beforeUpload={(file) => beforeUpload(file)}
            customRequest={(info) => handleFileUpload(info)}
            fileList={file}
            onRemove={() => {
              setFile([]);
            }}
          >
            {file.length < 1 && (
              <Button icon={<UploadOutlined />}>Upload Banner Image</Button>
            )}
          </Upload>
          {file.length > 0 && (
            <div className="mt-2">
              <Image width={100} src={file[0].url} />
            </div>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddBanner;
